import React, { useEffect, useState } from 'react';
import c from 'classnames';

import { TOOLTIP_MARGIN_THRESHOLD } from '../../config/constants';
import useWindowDimensions from '../../hooks/useWindowDimensions';

import './style.scss';

export interface TooltipProps {
  targetRef: React.MutableRefObject<HTMLDivElement>;
  className?: string;
  children: React.ReactNode;
}

const Tooltip: React.FC<TooltipProps> = (props) => {
  const {
    targetRef,
    className,
    children,
  } = props;

  const { width: screenWidth } = useWindowDimensions();
  const [margin, setMargin] = useState(0);
  const classNames = c('Tooltip', className);

  useEffect(() => {
    if (targetRef.current) {
      const { x, width } = targetRef.current.getBoundingClientRect();

      let newMargin = 0;

      if (x < 0) {
        newMargin = x - TOOLTIP_MARGIN_THRESHOLD;
      }

      if (screenWidth - x < width) {
        newMargin = Math.round(width - (screenWidth - x) + Number(TOOLTIP_MARGIN_THRESHOLD));
      }

      setMargin(newMargin);
    }
  }, [targetRef, screenWidth]);

  return (
    <div
      ref={targetRef}
      className={classNames}
      style={{ marginLeft: -margin }}
    >
      {children}
      <div className="Tooltip__pointer" style={{ marginLeft: margin }} />
    </div>
  );
};

export default Tooltip;
